import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";

import PublicLayout from "@/components/public/PublicLayout";
import AppLayout from "@/components/app/AppLayout";
import AdminLayout from "@/components/admin/AdminLayout";

import PublicHome from "@/pages/public/Home";
import {
    CommentCaMarche, DevenirDresseur, Charte, FAQ, CGU, Confidentialite, MentionsLegales,
} from "@/pages/public/InfoPages";

import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import AdminLogin from "@/pages/auth/AdminLogin";

import AppHome from "@/pages/app/AppHome";
import AppMissions from "@/pages/app/AppMissions";
import AppMissionNew from "@/pages/app/AppMissionNew";
import AppMissionDetail from "@/pages/app/AppMissionDetail";
import AppStack from "@/pages/app/AppStack";
import AppProfile from "@/pages/app/AppProfile";
import AppExplorer from "@/pages/app/AppExplorer";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminBrandTheme from "@/pages/admin/AdminBrandTheme";
import AdminBrand from "@/pages/admin/AdminBrand";
import AdminAuditLogs from "@/pages/admin/AdminAuditLogs";
import AdminCatalogue from "@/pages/admin/AdminCatalogue";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminPricing from "@/pages/admin/AdminPricing";
import {
    AdminMissions, AdminVendors,
    AdminPayments, AdminDisputes, AdminShipping, AdminEmails,
} from "@/pages/admin/AdminPlaceholders";

export default function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Public site */}
                        <Route element={<PublicLayout />}>
                            <Route index element={<PublicHome />} />
                            <Route path="/comment-ca-marche" element={<CommentCaMarche />} />
                            <Route path="/devenir-dresseur" element={<DevenirDresseur />} />
                            <Route path="/charte" element={<Charte />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route path="/cgu" element={<CGU />} />
                            <Route path="/confidentialite" element={<Confidentialite />} />
                            <Route path="/mentions-legales" element={<MentionsLegales />} />
                        </Route>

                        {/* Auth */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/admin/login" element={<AdminLogin />} />

                        {/* PWA (authenticated public users) */}
                        <Route path="/app" element={<AppLayout />}>
                            <Route index element={<AppHome />} />
                            <Route path="explorer" element={<AppExplorer />} />
                            <Route path="missions" element={<AppMissions />} />
                            <Route path="missions/new" element={<AppMissionNew />} />
                            <Route path="missions/:mid" element={<AppMissionDetail />} />
                            <Route path="stack" element={<AppStack />} />
                            <Route path="profil" element={<AppProfile />} />
                        </Route>

                        {/* Admin cockpit */}
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route index element={<AdminDashboard />} />
                            <Route path="missions" element={<AdminMissions />} />
                            <Route path="utilisateurs" element={<AdminUsers />} />
                            <Route path="vendeurs" element={<AdminVendors />} />
                            <Route path="catalogue" element={<AdminCatalogue />} />
                            <Route path="categories" element={<AdminCategories />} />
                            <Route path="pricing" element={<AdminPricing />} />
                            <Route path="paiements" element={<AdminPayments />} />
                            <Route path="litiges" element={<AdminDisputes />} />
                            <Route path="transport" element={<AdminShipping />} />
                            <Route path="emails" element={<AdminEmails />} />
                            <Route path="brand-theme" element={<AdminBrandTheme />} />
                            <Route path="brand" element={<AdminBrand />} />
                            <Route path="parametres" element={<AdminSettings />} />
                            <Route path="audit" element={<AdminAuditLogs />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster position="top-right" />
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}
